import { Col, Row } from "antd";
import {
  forwardRef,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { getKey } from "../../components/utils/utils";
import GreyButton from "../Buttons/GreyButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import Inputs from "../Inputs/Inputs";
interface ShareProps {
  share_ids: any;
  donation_type_ids: any;
  remainingAmount: number;
  type: "المشاريع" | "تفريج كرب" | "التبرع العام";
  isCompleted?: boolean;
  setDonationAmount?: (value: SetStateAction<number>) => void;
  setCounter?: (value: SetStateAction<number>) => void;
  setSelectedShare?: (value: SetStateAction<any>) => void;
  setSelectedDonation?: (value: SetStateAction<any>) => void;
  setTotalAmount?: (value: any) => void;
  donationAmount?: any;
  project: any;
  selectedDonation?: any;
  counter?: any;
  selectedShare?: any;
  container: "card" | "donation" | "payment";
}

const calculateShare = (
  share: any,
  multiple: number,
  amount: number,
  type: string,
  remainingAmount: any
) => {
  if (type === "تفريج كرب" || type === "التبرع العام") {
    return amount && remainingAmount
      ? Math.min(multiple * amount, remainingAmount)
      : amount;
  }
  if (!share) return amount;
  /** share is blocked */
  if (!share?.open_share) {
    return Math.min(multiple * share?.amount, remainingAmount);
  }
  /** share is open*/
  if (share?.amount === 0) {
    //amout is free
    let value = amount;
    for (let index = 1; index <= multiple; index++) {
      value *= index;
    }
    return value;
  } else if (amount === share?.amount || amount === 0) {
    return Math.min(multiple * share?.amount, remainingAmount);
  } else {
    return Math.min(multiple * amount, remainingAmount);
  }
};
const Share = forwardRef(
  (
    {
      remainingAmount,
      share_ids,
      donation_type_ids,
      type,
      isCompleted,
      setDonationAmount,
      setCounter,
      setSelectedShare,
      setSelectedDonation,
      setTotalAmount,
      selectedDonation,
      counter,
      selectedShare,
      donationAmount,
      container,
      project,
    }: ShareProps,
    ref
  ) => {
    const navigate = useNavigate();
    const [activeDonation, setActiveDonation] = useState<any>(
      selectedDonation ?? null
    );
    const [activeShare, setActiveShare] = useState<any>(selectedShare ?? null);
    const [multipleValue, setMultipleValue] = useState<number>(counter ?? 1);
    const [amount, setAmount] = useState<number>(donationAmount);
    const result = useMemo(
      () =>
        calculateShare(
          activeShare,
          multipleValue,
          amount,
          type,
          remainingAmount
        ),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [activeShare, multipleValue, amount, remainingAmount]
    );
    const getActiveDonation = () => {
      return activeDonation;
    };

    useImperativeHandle(ref, () => ({
      getActiveDonation: getActiveDonation,
    }));

    useEffect(() => {
      if (!selectedShare) {
        share_ids?.length === 1
          ? setActiveShare(share_ids[0])
          : setActiveShare(null);
      }
      if (!activeDonation || !selectedDonation) {
        donation_type_ids.length > 0
          ? setActiveDonation(donation_type_ids[0])
          : setActiveDonation(null);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [share_ids, donation_type_ids]);

    const resetAmount = (value: number) => {
      setAmount(value);
      setMultipleValue(1);
      if (setCounter) setCounter(1);

      if (setDonationAmount) setDonationAmount(value);
    };

    useEffect(() => {
      if (setTotalAmount)
        setTotalAmount(
          remainingAmount
            ? Math.min(
                result === 0 ? activeShare?.amount : result,
                remainingAmount
              )
            : result === 0
            ? activeShare?.amount
            : result
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [result]);

    useEffect(() => {
      if (setSelectedShare) setSelectedShare(activeShare);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeShare]);
    useEffect(() => {
      if (setSelectedDonation) setSelectedDonation(activeDonation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDonation]);

    const toDisplayMultiplicator = () => {
      if (container === "card") return true;
      if (container === "payment") return true;

      return false;
    };

    return (
      <>
        {/* Donation type buttons hidden on project cards & project details — REQUESTED BY CLIENT */}
        {/* <Row justify={"space-between"} style={{ gap: 5, display: "flex" }}>
          {container === "card"
            ? donation_type_ids.map((el: any) => (
                <GreyButton
                  disabled={isCompleted}
                  key={el.id}
                  className={`${
                    activeDonation?.id == el.id
                      ? "takaful--grey-button-active"
                      : ""
                  }`}
                  title={el.name}
                  onClick={() => setActiveDonation(el)}
                />
              ))
            : donation_type_ids.map((el: any) => (
                <PrimaryButton
                  disabled={isCompleted}
                  key={el.id}
                  className={
                    activeDonation?.id === el.id ? "active-btn" : "inactive-btn"
                  }
                  title={el.name}
                  style={{ padding: "0.7rem 1rem" }}
                  onClick={() => setActiveDonation(el)}
                />
              ))}
        </Row> */}
        {container !== "card" && type !== "المشاريع" && (
          <Row justify={"space-between"} style={{ gap: 5, display: "flex" }}>
            {donation_type_ids.map((el: any) => (
              <PrimaryButton
                disabled={isCompleted}
                key={el.id}
                className={
                  activeDonation?.id === el.id ? "active-btn" : "inactive-btn"
                }
                title={el.name}
                style={{ padding: "0.7rem 1rem" }}
                onClick={() => setActiveDonation(el)}
              />
            ))}
          </Row>
        )}
        <div
          style={{
            gap: "0.3rem",
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            minHeight:
              // eslint-disable-next-line eqeqeq
              type == "المشاريع" && container === "card" ? "4vh" : "auto",
          }}
        >
          {container === "card"
            ? share_ids?.map((el: any) => (
                <GreyButton
                  disabled={isCompleted}
                  key={el.id}
                  className={
                    activeShare?.id === el.id
                      ? "takaful--grey-button-active"
                      : ""
                  }
                  title={el.name}
                  onClick={() => {
                    setAmount(el.amount);
                    setDonationAmount && setDonationAmount(el.amount);
                    setActiveShare(el);
                    setMultipleValue(1);
                    if (setSelectedShare) setSelectedShare(activeShare);
                    if (setCounter) setCounter(1);
                  }}
                />
              ))
            : share_ids?.map((el: any) => (
                <PrimaryButton
                  disabled={isCompleted}
                  key={el.id}
                  className={
                    activeShare?.id === el?.id ? "active-btn" : "inactive-btn"
                  }
                  title={el.name}
                  onClick={() => {
                    setAmount(el.amount);
                    setDonationAmount && setDonationAmount(el.amount);
                    setActiveShare(el);
                    setMultipleValue(1);
                    if (setSelectedShare) setSelectedShare(activeShare);
                    if (setCounter) setCounter(1);
                  }}
                />
              ))}
        </div>
        <Row style={{ width: "100%" }}>
          <Col
            span={
              container === "donation"
                ? "24"
                : container === "payment"
                ? "19"
                : "13"
            }
          >
            <div className="takaful--donation-input-with-prefix">
              <Inputs
                style={{
                  fontSize: "1.2rem",
                  border: "none",
                  height: "100%",
                  borderRadius: " 0 7px 7px 0",
                }}
                placeholder="مبلغ التبرع"
                maxLength={7}
                min={1}
                disabled={
                  type === "تفريج كرب" || type === "التبرع العام"
                    ? false
                    : (!activeShare?.open_share || isCompleted) &&
                      container !== "donation" && share_ids?.length > 0
                }
                value={!isNaN(result) && result !== 0 ? result : ""}
                onChange={(e) => {
                  const newValue = parseInt(e.target.value) ?? 0;
                  resetAmount(
                    remainingAmount
                      ? Math.min(newValue, remainingAmount)
                      : newValue
                  );
                }}
                sizeInput="middle"
                className="takaful--donation-input"
                type="number"
                withArrow={false}
              />
              <span className="takaful--donation-prefix icon-saudi_riyal"></span>
            </div>
            {amount > 0 && amount < 5 && (
              <p
                style={{ color: "red", fontSize: "1rem", marginTop: "4px" }}
                className="takaful--swal-font"
              >
                الحد الأدنى لمبلغ التبرع هو 5 ريال
              </p>
            )}
          </Col>
          {toDisplayMultiplicator() && (
            <Col span="4" className="takaful--with-arrow">
              <Inputs
                value={multipleValue}
                onChange={(e) => {
                  if (setCounter) setCounter(parseInt(e.target.value) || 0);
                  setMultipleValue(parseInt(e.target.value) || 0);
                }}
                sizeInput="middle"
                withArrow={true}
                className={`takaful--donation-input ${
                  container === "payment"
                    ? "takaful--input-payment-with-arrows"
                    : ""
                }`}
                type="number"
                style={{
                  height: "33px",
                  padding: "0 11px 0 0",
                  marginRight: "5px",
                  fontSize: "1rem",
                }}
                disabled={isCompleted}
              />
            </Col>
          )}
          {container === "card" && (
            <>
              {type === "المشاريع" ? (
                <Col span="7">
                  <PrimaryButton
                    disabled={!activeDonation || !activeShare}
                    className="takaful--donation-btn takaful--share-button"
                    title="ساهم الآن"
                    onClick={() =>
                      navigate(`/project/${project.id}`, {
                        state: {
                          donationAmount: amount,
                          counter: multipleValue,
                          selectedShare: activeShare,
                          selectedDonation: activeDonation,
                          type,
                        },
                      })
                    }
                    style={{ padding: "1rem 15px", float: "left" }}
                  />
                </Col>
              ) : (
                <Col span="7">
                  <PrimaryButton
                    disabled={!activeDonation}
                    className="takaful--donation-btn takaful--share-button"
                    title="ساهم الآن"
                    style={{ padding: "1rem 15px", float: "left" }}
                    onClick={() =>
                      navigate(
                        type === "تفريج كرب"
                          ? `/korba/${project.access_token}/${getKey(
                              project.model
                            )}`
                          : `/general-donation/${project.access_token}`,

                        {
                          state: {
                            donationAmount: amount,
                            counter: multipleValue,
                            selectedShare: activeShare,
                            selectedDonation: activeDonation,
                            type,
                          },
                        }
                      )
                    }
                  />
                </Col>
              )}
            </>
          )}
        </Row>
      </>
    );
  }
);

export default Share;
